import API from '@/views/Fdc/Apis/'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

/**
 * Report > Fault Analysis Report - Fault Detection Model Analysis Chart
 */
export default {
  name: 'FdModelAnalysisChart',
  props: {
    parentInfo: {
      type: Object,
      default () {
        return null
      }
    }
  },
  watch: {
    /**
     * parentInfo 변화 감지
     * Fault Detection Model Analysis Chart data를 조회합니다.
     */
    parentInfo () {
      this.search(this.parentInfo)
    }
  },
  methods: {
    /**
     * Fault Detection Model Analysis Chart data 조회
     * @param {Object} condition 조회 조건
     */
    async search (condition) {
      if (condition !== null) {
        let payload = {
          fab: condition.fab,
          area: condition.area,
          eqpModel: condition.eqpModel,
          eqpId: condition.eqpId,
          fromDate: condition.fromDate,
          toDate: condition.toDate
        }

        await API.Report.getFaultChartModels(payload, this.callbackEqpChart)
      } else {
        this.$emit('data-selected', null)
        BriqueChart.deleteTraces(document.querySelector('#fdModelChart'), 0)
      }
    },
    /**
     * Fault Detection Model Analysis Chart data 조회 callback
     * @param {*} response Fault Detection Model Analysis Chart data 조회 결과
     */
    callbackEqpChart (response) {
      if (response && response.status === 200) {
        this.drawChart(response.data)
        // this.fdModelAnalysisItems = response.data

        // if (this.fdModelAnalysisItems.length > 0) {
        //   this.$emit('data-selected', this.fdModelAnalysisItems[0])

        //   this.selectedIndex = 0
        // }
      }
    },
    /**
     * Draw Chart
     * @param {*} traces plotly chart data
     */
    drawChart (traces) {
      // private final String name = "Model Name";
      // private final String type = "bar";
      // private final String orientation = "h";
      // private final String hovertemplate = "Fab: %{text.fab}<br>Area: %{text.area}<br>EQP Model: %{text.eqpModel}<br>EQP: %{text.eqp}<br>Model Type: %{text.modelType}<br>Model name: %{text.modelName}<br>Recipe: %{text.recipe}<br>Step: %{text.step}<br>Cnt: %{value:,}<extra></extra>";

      let yLength = 0
      traces.forEach(trace => {
        trace.name = 'Model Name'
        trace.type = 'bar'
        trace.orientation = 'h'
        trace.hovertemplate = '<b>Fab:</b> %{text.fab}<br><b>Area:</b> %{text.area}<br><b>EQP Model:</b> %{text.eqpModel}<br><b>EQP:</b> %{text.eqp}<br><b>Model Type:</b> %{text.modelType}<br><b>Model name:</b> %{text.modelName}<br><b>Recipe:</b> %{text.recipe}<br><b>Step:</b> %{text.step}<br><b>Cnt:</b> %{value:,}<extra></extra>'
        let maxLength = Math.max.apply(Math, trace.y.map(function (el) { return el.length }))
        if (yLength < maxLength) {
          yLength = maxLength
        }
      })

      const layout = {
        legend: {
          orientation: 'h',
          y: 1.2
        },
        margin: {
          l: yLength * 10
        },
        hoverlabel: {
          align: 'left'
        }
      }
      const config = {
        responsive: true,
        scrollZoom: true,
        displaylogo: false,
        displayModeBar: true
      }
      BriqueChart.newPlot('fdModelChart', traces, layout, config)
    }
  },
  data () {
    return {
      // fdModelAnalysisItems: [] // Fault Detection Model Analysis Chart data
      // selectedIndex: null // 선택된 chart data index
    }
  }
}
